import { getUserSession } from "../_services/localstorage";
import { isUserTechnician } from "./is-user-technician";
import { isUserClient } from "./is-user-client";

export const isUserManager = () => {
  const currentUser = getUserSession();

  return currentUser
    && !isUserTechnician(currentUser)
    && !isUserClient(currentUser);
};
